import { useCallback, useState } from 'react';

import type { TrashLogState } from '../types';

const initialState = (date: string): TrashLogState => ({
  date,
  entries: [],
});

export function useTrashLogForm(date: string) {
  const [state, setState] = useState<TrashLogState>(() => initialState(date));
  const [logId, setLogId] = useState<string | null>(null);

  const setField = <K extends keyof TrashLogState>(field: K, value: TrashLogState[K]) =>
    setState((prev) => ({ ...prev, [field]: value }));

  const prefillForm = useCallback((next: TrashLogState, id: string | null) => {
    setState(next);
    setLogId(id);
  }, []);

  const resetForm = useCallback((resetDate: string) => {
    setState(initialState(resetDate));
    setLogId(null);
  }, []);

  return {
    state,
    logId,
    setField,
    setState,
    setLogId,
    prefillForm,
    resetForm,
  };
}
